export default __webpack_public_path__ + "static/media/google_wallet.7c8068d8.svg";